import React, { useState, useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { useTranslation } from "react-i18next";

const QuantityWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const SpinnerWrapper = styled.div`
  display: flex;

  .minus,
  .plus {
    display: flex;
    justify-content: center;
    align-items: center;
    border: var(--thin-border) var(--gray-4);
    border-radius: var(--border-radius);
    cursor: pointer;
    width: 32px;
    height: 32px;
    padding: 20px;
    .MuiSvgIcon-root {
      stroke: none;
      fill: var(--primary-icon-2);
    }
  }

  > :not(:last-child) {
    margin-right: 5px;
  }

  /* To Hide built in spinner for input type 'number' */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    display: none;
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
`;
const LabelBold = styled.label`
  font-weight: var(--font-weight-medium);
`;

const InputBox = styled.input`
  ${({ isInvalid }: { isInvalid: boolean }) => css`
    display: inline;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    width: clamp(25px, 60%, 45px);
    border-bottom: var(--thin-border) gray;
    padding-right: 0px;
    border-color: ${isInvalid ? "var(--red)" : "none"};
    color: ${isInvalid ? "var(--red)" : "none"};
    text-align: center;
  `}
`;
interface Iprops extends React.HTMLAttributes<HTMLDivElement> {
  showLabel?: boolean;
  quantity?: number;
  onChange?: any;
  labelBold?: boolean;
  isInvalid?: boolean;
  itemNumberOfDecimalsAllowed?: number;
}

const Quantity = ({
  showLabel = true,
  quantity = 1,
  onChange,
  isInvalid = false,
  itemNumberOfDecimalsAllowed = 0,
  ...props
}: Iprops) => {
  const [newQuantity, setNewQuantity] = useState(quantity);
  const [isValid, setIsValid] = useState(true);
  const { t } = useTranslation();

  const ref = useRef(false);

  // Add Item Quantity Handler
  const reduceQuantity = () => {
    setNewQuantity((prevQuantity) =>
      prevQuantity > 1 ? Number(prevQuantity) - Number(1) : 1
    );
  };

  // Remove Item Quantity Handler
  const addQuantity = () => {
    setNewQuantity((prevQuantity) => Number(prevQuantity) + Number(1));
  };

  const setQuantity = (val: any) => {
    setNewQuantity(Number(val));
  };

  useEffect(() => {
    setQuantity(quantity);
  }, [quantity]);

  useEffect(() => {
    setIsValid(!isInvalid);
  }, [isInvalid]);

  useEffect(() => {
    var split = newQuantity?.toString()?.split(".");
    const isDot: boolean = newQuantity?.toString()?.trim()?.includes(".");
    if (
      itemNumberOfDecimalsAllowed !== null &&
      itemNumberOfDecimalsAllowed !== undefined &&
      Number(itemNumberOfDecimalsAllowed) === Number(0) &&
      isDot
    ) {
      setIsValid(false);
    } else if (
      itemNumberOfDecimalsAllowed !== null &&
      itemNumberOfDecimalsAllowed !== undefined &&
      split !== null &&
      split !== undefined &&
      split?.length > 1 &&
      Number(split[1]?.trim().length) > Number(itemNumberOfDecimalsAllowed)
    ) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
  }, [itemNumberOfDecimalsAllowed]);

  useEffect(() => {
    var split = newQuantity?.toString()?.split(".");
    const isDot: boolean = newQuantity?.toString()?.trim()?.includes(".");
    let isValid = true;
    if (
      itemNumberOfDecimalsAllowed !== null &&
      itemNumberOfDecimalsAllowed !== undefined &&
      Number(itemNumberOfDecimalsAllowed) === Number(0) &&
      isDot
    ) {
      isValid = false;
      setIsValid(false);
    } else if (
      itemNumberOfDecimalsAllowed !== null &&
      itemNumberOfDecimalsAllowed !== undefined &&
      split !== null &&
      split !== undefined &&
      split?.length > 1 &&
      Number(split[1]?.trim().length) > Number(itemNumberOfDecimalsAllowed)
    ) {
      isValid = false;
      setIsValid(false);
    } else {
      isValid = true;
      setIsValid(true);
    }
    if (!ref.current) {
      ref.current = true;
      return;
    }
    onChange(newQuantity, isValid);
  }, [newQuantity]);

  return (
    <QuantityWrapper {...props}>
      {showLabel && (
        <>
          {props.labelBold ? (
            <LabelBold className="">{t("CON_QUANTITY")}</LabelBold>
          ) : (
            <label className="">{t("CON_QUANTITY")}</label>
          )}
        </>
      )}
      <SpinnerWrapper className="mt-2">
        <div onClick={reduceQuantity} className="plus">
          <RemoveIcon className="primary-icon-2" />
        </div>
        <InputBox
          className="quantityValue"
          value={newQuantity}
          // pattern= {`^\d*(\.\d{0,${itemNumberOfDecimalsAllowed}})?$`}
          type="number"
          isInvalid={!isValid}
          onChange={(e: any) => {
            setQuantity(e.target.value);
          }}
        />
        <div onClick={addQuantity} className="minus">
          <AddIcon className="primary-icon-2" />
        </div>
      </SpinnerWrapper>
    </QuantityWrapper>
  );
};

export default Quantity;
